import { AuthModuleState } from '../auth.state';
export const selectLoggedInUser = (state: AuthModuleState) => state?.user;
export const selectLoggedInUtilityHubIdentity = (state: AuthModuleState) => state?.utilityHubIdentity;